// extracted by mini-css-extract-plugin
export default {"promptSuggestionsContainer":"PromptSuggestions_promptSuggestionsContainer__w5BT-"};